const STORAGE_KEY = 'billing_filters_v1';

export const loadBillingFilters = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const saveBillingFilters = (partial) => {
  try {
    const prev = loadBillingFilters();
    const next = { ...prev, ...(partial || {}) };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  } catch {
    return null;
  }
};

export const clearBillingCompanyFilter = () => {
  return saveBillingFilters({
    companyId: null,
    companyConfigId: null,
    companyName: null,
  });
};



